import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

interface Videos {
    name:string;
    url: string;
}

interface Resource {
    title: string;
    url: string;
}

interface Lecture {
    title: string;
    video: Videos[];
    quizId?: string;
    resources?: Resource[];
}

interface AddChapterDTO {
    name: string;
    courseId: string;
    description:string;
    lectures: Lecture[];
}

interface ChapterResponse extends AddChapterDTO, ApiError {
    id: string;
    createdAt: string;
    updatedAt: string;
}
export const AddNewChapter = (data: AddChapterDTO): Promise<ChapterResponse> => {
    return axios.post("/chapter/create", data)
        .then(response => response.data as ChapterResponse);
};